import { useState } from 'react';
import { Alignments, classFromProperties, getOptionalProps, getUniqId, Paddings, Sizes } from '../../ui-helpers';
import './card-box.css';

/**
 * CardBox component.
 * @param {ReactDOM.props} props Component properties.
 * @returns CardBox component.
 */
 const CardBox = (props) => {
    
    // Excluded properties for automatic properties propagation
    const Excluded = ['id'].concat(Alignments, Paddings, Sizes);

    // Initialize states
    const [ id ] = useState(props?.id ? props.id : getUniqId())

    // Always include 'card-box' class
    const userClass = props.className ? props.className : '';
    const classes = ['card-box', userClass, classFromProperties(props, '', Alignments, Paddings)].filter(Boolean).join(' ');
    return (
        <div
            id={id}
            className={classes}
            {...getOptionalProps(props, Excluded)}
        >
            {props.children}
        </div>
    );
}

/**
 * CardBoxHeader component for section headers with icon and title.
 * @param {object} props
 * @param {React.ReactNode} props.icon - Icon to display on the left
 * @param {React.ReactNode} props.children - Title text
 * @returns {JSX.Element}
 */
export const CardBoxHeader = ({ icon, children }) => (
  <div className="dossier-header">
    {icon && <span className="dossier-header-icon">{icon}</span>}
    <span className="dossier-header-title">{children}</span>
  </div>
);

export default CardBox;
